<!-- @format -->
<template>
	<van-nav-bar
		class="pcp-mo-nav-bar"
		:title="moglobalStore.navigationBar.title"
		:left-text="moglobalStore.navigationBar.leftText"
		:left-arrow="moglobalStore.navigationBar.leftArrow"
		@click-left="moglobalStore.navigationBar.onClickBack"
	/>
	<div class="pcp-mo-layout-main">
		<!-- <div class="status_bar">

		</div> -->

		<router-view #="{ Component }">
			<component :is="Component" :key="route.name" />
		</router-view>

		<van-tabbar v-model="moglobalStore.tabbar.active" @change="onChange">
			<van-tabbar-item v-for="menu in moglobalStore.curTabbarMenu" :key="menu.id" :icon="menu.appIcon">
				<span>{{ menu.name }}</span>
				<template #icon="props">
					<img
						:src="
							props.active
								? menu.appIconActive || getFilePreviewUrlById(menu.appIcon)
								: getFilePreviewUrlById(menu.appIcon)
						"
					/>
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script lang="ts" setup>
	import { setObjToUrlParams, getQueryObject, isHttp } from '@power/utils';
	import { getFilePreviewUrlById, useGlobalStoreWithOut, getFirstWordFromLocationPathname } from '@power/runtime-vue3';
	import { useMenuStore } from '@/store/modules/menu';
	import { useMoGlobalStoreWithOut } from '@/store/modules/moglobal';
	const globalStore = useGlobalStoreWithOut();

	const moglobalStore = useMoGlobalStoreWithOut();
	const menuStore = useMenuStore();
	const route = useRoute();
	const router = useRouter();
	const curTabbarMenu = menuStore.menusRes.filter((menu) => {
		if (menu.parentId === '0') {
			return menu;
		}
	});
	const onChange = (index) => {
		// console.log('curTabbarMenu[index]', moglobalStore.curTabbarMenu[index]);

		const { resourceType, defaultUrl, id, name, alias, sysType } = curTabbarMenu[index];

		let path = '';
		let query = {};
		if ('menu' === resourceType) {
			const { curSystem } = globalStore;
			const curSystemAlias = curSystem.alias;
			let newPath = '';
			const firstWord = getFirstWordFromLocationPathname(defaultUrl);

			if ('outer' === sysType) {
				// outer
				if (isHttp(defaultUrl)) {
					newPath = defaultUrl;
				} else {
					newPath = `${window.location.origin}${defaultUrl}`;
				}
				path = `/outer-link`;
				query = {
					// hideLeftArrow: '0',
					targeturl: encodeURIComponent(newPath),
					navigationBarTitle: name,
					tabbarActive: index,
				};
			} else if ('inner' === sysType) {
				// inner
				path = `/inner-link`;
				query = {
					hideLeftArrow: '1',
					targeturl: encodeURIComponent(defaultUrl),
					navigationBarTitle: name,
					tabbarActive: index,
				};
			} else if ('self' === sysType) {
				// self
				if (curSystemAlias === firstWord) {
					newPath = defaultUrl.substring(curSystemAlias.length + 1);
				} else {
					newPath = defaultUrl;
				}
				path = newPath.split('?')[0];
				query = {
					hideLeftArrow: '1',
					navigationBarTitle: name,
					tabbarActive: index,
					...getQueryObject(newPath),
				};
			}
		} else if ('dir' === resourceType) {
			path = '/menu';
			query = {
				hideLeftArrow: '1',
				id,
				navigationBarTitle: name,
				tabbarActive: index,
				menuType: alias.indexOf('-menulist-p-builtin') > -1 ? 'list' : undefined,
			};
		}
		const unistring = setObjToUrlParams(path, query);
		if (location.href.indexOf(unistring) > -1) {
			return;
		}
		moglobalStore.setNavigationBar({
			title: name,
			leftArrow: false,
		});
		router.push({
			path,
			query,
		});
	};
	if ('/' === route.path) {
		moglobalStore.setCurTabbarMenu(curTabbarMenu, onChange);
	} else {
		moglobalStore.setCurTabbarMenu(curTabbarMenu);
	}
</script>

<style scoped lang="scss">
	.pcp-mo-layout-main {
		// padding-top: 30px;
		margin-top: var(--status-bar-nav-bar-height);
		margin-bottom: var(--van-tabbar-height);
		background-color: var(--h5-background-color);
		overflow: auto;
	}
</style>
